import { render } from "./Order.vue?vue&type=template&id=39c662fc&scoped=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=39c662fc&lang=scss"
import "./Order.vue?vue&type=style&index=1&id=39c662fc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-39c662fc"

export default script